import { useEffect, useRef } from "react";

/**
 * Scroll-reveal for /start sections. Same contract as home/useReveal but
 * emits `st-reveal--*` classes so home.css never needs importing here.
 * Prerender-safe: no-op under navigator.webdriver / reduced motion.
 */
export default function useStartReveal() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof window === "undefined" || navigator.webdriver) return undefined;
    if (!("IntersectionObserver" in window)) return undefined;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;

    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.9) return undefined;

    el.classList.add("st-reveal--pending");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.remove("st-reveal--pending");
            el.classList.add("st-reveal--in");
            observer.disconnect();
          }
        });
      },
      { rootMargin: "0px 0px -40px 0px", threshold: 0.05 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return ref;
}
